import { Button } from '@material-ui/core'
import { Field } from '../../form'

const ValttiImageMobile = ({ t, isDisabledField, picture, imageHandler, helpertext, control, classes }) => {
    return (
        <div className="col-xs-12 col-sm-12 col-lg-12" style={{ padding: 0 }}>
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{t('taxArea.title3')}</h3>
                </div>
                <div className="panel-body">
                    <div className={classes.imageFieldContainer} style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ width: '100%', marginBottom: '10px' }}>
                            <img
                                src={picture}
                                className="img-fluid img-thumbnail"
                                style={{
                                    margin: 'auto',
                                    aspectRatio: '3 / 4',
                                    minWidth: '100%',
                                    border: helpertext !== '' ? '1px solid #F44336' : '',
                                    backgroundColor: '#F5F5F5'
                                }}
                            />
                        </div>
                        <Button
                            variant="contained"
                            className={classes.buttonFile}
                            component="label"
                            htmlFor="input-image"
                            disabled={isDisabledField}
                            style={{ marginBottom: '10px', width: '100%' }}
                        >
                            {t('taxArea.btn1')}
                        </Button>
                        <div className="dashboard-tax-input">
                            <Field
                                name="inputImage"
                                inputType="file"
                                id="input-image"
                                control={control}
                                accept="image/*"
                                onChange={imageHandler}
                                disabled={isDisabledField}
                            />
                        </div>
                        <div style={{ width: '100%', color: '#808080', textAlign: 'left', paddingLeft: '15px' }}>
                            <ul style={{ margin: '0 0 10px', padding: '0', width: '100%' }}>
                                <li><p>{t('taxArea.p1')}</p></li>
                                <li><p>{t('taxArea.p2')}</p></li>
                                <li><p>{t('taxArea.p3')}</p></li>
                                <li><p>{t('taxArea.p4')}</p></li>
                                <li><p>{t('taxArea.p5')}</p></li>
                                <li><p>{t('taxArea.p6')}</p></li>
                                <li><p>{t('taxArea.p7')}</p></li>
                            </ul>
                        </div>
                        {helpertext && (
                            <div style={{ color: '#F44336', fontSize: '8px', marginTop: '3px' }}>
                                {helpertext}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ValttiImageMobile
